import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

import DialogModal from "../../common/DialogModal";
import Button from "../../Parts/Button";
import InputComponent from "../../common/InputComponent";

import { validateSender } from "../../../utils/validator";
import { DialogType } from "../../../constants/ComponentTypes";

const styles = () => ({
  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
  },

  contentContainer: {
    padding: "0 25px 25px 25px",
    margin: 0,
    textAlign: "left",
  },

  buttonContainer: {
    display: "inline-flex",
    width: "100%",
    justifyContent: "space-evenly",
    margin: "50px 0",
  },

  fullWidth: {
    width: "100%",
  },

  tooltip: {
    backgroundColor: "#d32f2f",
    width: "100%",
    maxWidth: "335px",
  },

  input: {
    boxSizing: "border-box",
  },
});

export const formProps = [
  { key: "name", value: "名前", placeholder: "名前を入力" },
];

class EditOrderContactDialog extends React.Component {
  constructor(props) {
    super(props);

    let initialState = {
      name: "",
      error: {},
      saveBtnPressed: false,
    };

    if (props.item) {
      for (let key in initialState) {
        initialState[key] = props.item[key]
          ? props.item[key]
          : initialState[key];
      }
    }

    this.state = { ...initialState };
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.isSaving &&
      !nextProps.isSaving &&
      nextProps.error === null
    ) {
      nextProps.toggleDialog();
    }

    if (nextProps.error) {
      this.setState({
        error: nextProps.error,
      });
    }
  }

  handleChange = (property) => (event) => {
    let value = event.target.value;

    //２回目からタイピングごとでチェック
    if (this.state.saveBtnPressed) {
      this.validateForm({ ...this.state, [property]: value });
    }

    this.setState({
      [property]: value,
    });
  };

  handleSave = () => {
    let { error, saveBtnPressed, ...data } = this.state;
    if (!saveBtnPressed) error = this.validateForm(data);

    if (Object.keys(error).length === 0) {
      if (this.props.type === DialogType.EDIT && this.props.item) {
        data["order_contact_id"] = this.props.item.id;
      }
      this.props.save(data);
    } else {
      this.setState({
        saveBtnPressed: true,
      });
    }
  };

  //Blur the input field when Enter key is pressed
  handleEnterKeyPressed = (e) => {
    const enterKeyCode = 13;
    if (e.keyCode === enterKeyCode) {
      this.handleSave();
    }
  };

  validateForm = (state = {}) => {
    let error = validateSender(state);

    this.setState({
      error: error,
    });

    return error;
  };

  countErrors = () => {
    return Object.keys(this.state.error).length;
  };

  render() {
    const { classes, toggleDialog, isSaving, type } = this.props;
    const { error } = this.state;

    return (
      <DialogModal
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
        open={this.props.isOpen}
        maxWidth={false}
        onClose={toggleDialog}
        title={`注文担当者を${type === DialogType.CREATE ? "登録" : "編集"}`}
      >
        {formProps.map((prop, i) => (
          <div className={classes.fullWidth} key={i}>
            <InputComponent
              title={prop.value}
              placeholder={prop.placeholder}
              value={this.state[prop.key]}
              onChange={this.handleChange(prop.key)}
              error={error[prop.key] ? error[prop.key] : ""}
              onKeyDown={this.handleEnterKeyPressed}
            />
          </div>
        ))}
        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={this.props.toggleDialog}
            size="large"
            type="ghost"
            text="キャンセル"
            style={{ background: "transparant" }}
          ></Button>
          <Button
            handleClickButton={this.handleSave}
            size="large"
            disabled={this.countErrors() !== 0}
            loading={isSaving}
            text="保存"
          ></Button>
        </div>
      </DialogModal>
    );
  }
}

EditOrderContactDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
  error: PropTypes.object,
  item: PropTypes.object,
  type: PropTypes.string,
};

export default withStyles(styles)(EditOrderContactDialog);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Basic/EditOrderContactDialog.jsx